import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import ForumIcon from '@mui/icons-material/Forum';
import { useAppDispatch } from 'app/hooks';
import { feedbackActions } from 'features/feedback/store/feedback.slice';

const FeedbackTrigger: React.FC = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const open = () => dispatch(feedbackActions.openDrawer());

  if (isMobile) {
    return (
      <Box
        role="button"
        aria-label="Надіслати відгук"
        onClick={open}
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
        sx={{
          position: 'fixed', right: 16, bottom: 20, zIndex: 1200,
          height: 52, px: 2, display: 'flex', alignItems: 'center', gap: 1,
          borderRadius: '999px', background: '#3B2C93', color: '#fff', cursor: 'pointer',
          boxShadow: '0 8px 22px rgba(59,44,147,.4)',
        }}
      >
        <ForumIcon sx={{ fontSize: 22 }} />
        <span style={{ fontSize: 14, fontWeight: 600 }}>Відгук</span>
      </Box>
    );
  }

  return (
    <Box
      role="button"
      aria-label="Надіслати відгук"
      onClick={open}
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
      sx={{
        position: 'fixed', right: 0, top: '50%', transform: 'translateY(-50%)', zIndex: 1200,
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px',
        padding: '10px 5px', cursor: 'pointer',
        background: '#3B2C93', color: '#fff', borderRadius: '10px 0 0 10px',
        boxShadow: '-4px 4px 16px rgba(59,44,147,.28)',
      }}
    >
      <ForumIcon sx={{ fontSize: 18 }} />
      <span style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', fontSize: 12.5, fontWeight: 600 }}>
        Відгук
      </span>
    </Box>
  );
};

export default FeedbackTrigger;
